import React from 'react'
import './services.css'

function Services() {
  return (
    <div>
      <div class="scontainer">
   <h2>
    Our Service
   </h2>
   <h1>
    What We Provide
   </h1>
   <div class="sservices">
    <div class="sservice-item" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
     <img alt="Close-up image of corn cobs" height="300" src="https://images.unsplash.com/photo-1596560548464-f010549b84d7?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJpY2V8ZW58MHx8MHx8fDA%3D" width="200"/>
     <p>
      Retail Rice Sales
     </p>
    </div>
    <div class="sservice-item" data-aos="flip-up">
     <img alt="Hand holding freshly harvested carrots" height="300" src="https://images.unsplash.com/photo-1705147289789-6df2593f1b1e?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzF8fHJpY2V8ZW58MHx8MHx8fDA%3D" width="200"/>
     <p>
      Wholesale & Bulk Supply
     </p>
    </div>
    <div class="sservice-item" data-aos="flip-down">
     <img alt="Various fresh vegetables including carrots and bitter melons" height="300" src="https://images.unsplash.com/photo-1643622357625-c013987d90e7?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDJ8fHJpY2V8ZW58MHx8MHx8fDA%3D" width="200"/>
     <p>
      Custom Packaging Solutions
     </p>
    </div>
    <div class="sservice-item" data-aos="fade-left"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
     <img alt="Close-up image of a cheese wheel with figs and walnuts" height="300" src="https://images.unsplash.com/photo-1644131447497-8723db691320?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDh8fHJpY2V8ZW58MHx8MHx8fDA%3D" width="200"/>
     <p>
      Export Services
     </p>
    </div>
   </div>
  </div>

    </div>
  )
}

export default Services
